export default __webpack_public_path__ + "static/media/logout.ec712f7d.svg";